import { InstanceStatus } from "@enos-monorepo/lib/types/FoodManagementTypes";
import axios from "axios";

export interface CreateDefectLog {
  companyId: string;
  companyLocationId: string;
  status?: InstanceStatus;
  defect: string;
  correctiveAction: string;
  preventiveMeasure: string;
  file: string;
  registeredBy: string;
}

export interface DefectLog {
  id: string;
  companyId: string;
  companyLocationId: string;
  status?: InstanceStatus;
  defect: string;
  correctiveAction: string;
  preventiveMeasure: string;
  file: string;
  registeredBy: string;
  creationDate: string;
}

export function addDefectLog(defectLog: CreateDefectLog) {
  return axios
    .post(`/DefectLogs/adddefectlog`, defectLog)
    .then((res) => res.data);
}

export function getAllDefectLogsByLocationId(companyLocationId: string) {
  return axios
    .get<DefectLog[]>(`/DefectLogs/getalldefectlogsbylocationid`, {
      params: { companyLocationId },
    })
    .then((res) => res.data);
}

export function getDefectLogById(id: string) {
  return axios
    .get<DefectLog>("DefectLogs/getdefectlogbyid", {
      params: { id: id },
    })
    .then((res) => res.data);
}

export function updateDefectLog(defectLog: Omit<DefectLog, "creationDate">) {
  return axios
    .put(`/DefectLogs/updatedefectlog`, defectLog)
    .then((res) => res.data);
}
